export default function Logo() {
  return (
    <span
      className="inline-flex items-center rounded-full bg-white px-4 py-1.5 shadow-[0_2px_14px_rgba(0,0,0,0.28)]"
      data-testid="brand-logo"
    >
      <img src="/assets/nexorbit-lockup.png" alt="NexOrbit Solutions LLP" className="h-7 w-auto" />
    </span>
  );
}
